// @flow
import { TitleBar, Toast } from "@shopify/app-bridge-react"
import {
    Button,
    Card,
    ChoiceList,
    Heading,
    Modal,
    Page,
    ProgressBar,
    Select,
    Stack,
    TextContainer,
} from "@shopify/polaris"
import * as React from "react"
// import { Modal } from "react-bootstrap"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import axios from "../../funcs/axios"
import formatDateTime from "../../utils/formatDateTime"
import Preloader from "../Preloader"
import PrivacyContent from "../TOSPage"
import Actions from "./../../actions"
import AppMain from "./../WishlistApp/AppMain"
import { iconsSet } from "./icons_set"
import "./styles.scss"
let clientUrl1 = "nautilus-puzzles.myshopify.com"
let clientUrl2 = "nhkstore1412.myshopify.com"
window.SHOPIFY_APP_HOST = ""

type Props = {
    actions: Object,
    app_data: Object,
    app_settings: Object,
    app_edited: Object,
    app_render: Object,
    acceptedDate: String,
    notification: Object,
}

type State = {
    app_settings: Object,
    wishlist_settings_edited: Array<Object>,
    compare_settings_edited: Array<Object>,
    general_settings_edited: Array<Object>,
    saveState: Boolean,
    showPrivacy: Boolean,
    appWaiting: Boolean,
    errorValidate: Object,
    // Predifined Icons Set
    iconsSet: Object,
    show: Boolean,
    showUpdate: Boolean,
}
function mapStateToProps(state) {
    return {
        app_edited: state.app_edited,
        app_render: state.app_render,
        pages: state.pages,
        plan: state.plan,
        pages_config: state.pages_config,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    }
}

class AppCont extends React.Component<Props, State> {
    /**
     * Init State
     */
    state = {
        app_settings: JSON.parse(JSON.stringify(this.props.app_settings)),
        wishlist_settings_edited: [],
        compare_settings_edited: [],
        general_settings_edited: [],
        saveState: false,
        showPrivacy: false,
        errorValidate: {
            error_1: "", // wishlist add class error
            error_2: "", // wishlist show class error
            error_2a: "", // wishlist remove class error
            error_3: "", // compare add class error
            error_4: "", // compare show class error
            error_4a: "", // compare remove class error
        },
        // Define default icons set
        iconsSet: iconsSet,
        show: false,
        selectReinstall: "0",
        selected: "",
        optionThemes: [],
        trialDay: 30,
        checkInstall: true,
        checkClose: true,
        checkSuccess: false,
        tabSelected: 0,
        active: false,
        parentTabs: 0,
        process: 0,
        checkProcess: false,
        showUpdate: false,
        released_update: "",
        themesInstall: [],
        metafieldId: 0,
    }

    static getDerivedStateFromProps(props, state) {
        const { wishlist_settings_edited, compare_settings_edited, general_settings_edited } =
            props.app_edited
        if (
            !wishlist_settings_edited.length &&
            !compare_settings_edited.length &&
            !general_settings_edited.length
        ) {
            return {
                ...state,
                saveState: false,
            }
        } else {
            return {
                ...state,
                saveState: true,
            }
        }
    }

    constructor(props: Props) {
        super(props)
        /**
         * Load app settings
         */

        this.state = {
            ...this.state,
            appWaiting: true,
            hasError: false,
            settingLoading: true,
            check: false,
        }

        this.updateMetafields(this.props)

        this.loadAppMailSettings()
        this.loadAppReminderMailSettings()

        this.loadPlanSettings(this.props)
        this.handleLoadAllTheme()

        this.checkInstallCode()
        this.checkUpdate()
        this.getMetafieldId()
        // this.loadBulkMetafieldsCompare()
        // this.test()
    }

    componentDidMount() {
        let originalDonate = $(".donate-button--original .donate-button")
        $(".donate-banner--outer-wrapper .donate-button").append(originalDonate)
        // this.loadAppSettings(this.props)
    }

    checkUpdate = () => {
        axios.get(`${window.SHOPIFY_APP_HOST}/admin/check-update`).then((res) => {
            this.setState({
                showUpdate: res.data.showUpdate,
                released_update: res.data.released_date,
            })
        })
    }

    loadBulkMetafieldsCompare = async () => {
        const { actions } = this.props
        try {
            const response = await axios.get(
                `${window.SHOPIFY_APP_HOST}/admin/load-metafields-bulk`,
            )
            if (!response.data.success)
                throw new Error({ success: false, message: "Can't get bulk metafield" })
            const list_attributes = response.data.payload
            // handle data
            // check data don't have collection
            const data_with_collection = list_attributes.filter((item) => item.includes("__"))
            const collection_temp = data_with_collection.map((item) => {
                return item.split("__")[1]
            })
            const collection = [...new Set(collection_temp)]
            const list_metafield_with_collection = collection.map((item) => {
                const arr = list_attributes.filter((data) => {
                    const collect = data.split("__")[1]
                    return item === collect
                })
                return {
                    key: item,
                    data: [...arr],
                }
            })

            actions.setAttributeCompare(list_metafield_with_collection)
        } catch (error) {
            console.log("error loadBulkMetafieldsCompare:>> ", error)
        }
    }

    // loadWebhook = () => {
    //     axios.get(`${window.SHOPIFY_APP_HOST}/admin/test-webhook`).then((res) => {
    //         let resObj = res.data
    //     })
    // }

    updateMetafields(props) {
        axios.get(`${window.SHOPIFY_APP_HOST}/admin/auto-update-metafield`).then(async (res) => {
            let checkInstallACF = await this.test()
            await this.checkInstallAT()
            if (res.data.isInstall) {
                this.loadSettings(props, res.data.app_settings, checkInstallACF)
            } else {
                this.loadAppSettings(props, checkInstallACF)
            }
        })
    }

    handleLoadAllTheme() {
        axios.get(`${window.SHOPIFY_APP_HOST}/admin/load-all-theme`).then((res) => {
            let themeData = res.data.themes
            let themesInstall = res.data.themesInstall
            let optionThemes = []
            themeData.map((item) => {
                let name = item.name
                if (item.role === "main") {
                    name += " (live)"
                    this.setState({ selected: item.id })
                }
                let obj = { label: name, value: item.id }
                optionThemes.push(obj)
            })
            this.setState({ optionThemes, themesInstall })
        })
    }

    getObjectKey(obj, keys) {
        for (let k in obj) {
            if (!keys) keys = []
            keys.push(k)
            if (typeof obj[k] === "object") {
                this.getObjectKey(obj[k], keys)
            }
        }
        return keys
    }

    checkInstallCode() {
        axios.get(`${window.SHOPIFY_APP_HOST}/admin/check-install-code`).then((response) => {
            const resObj = response.data
            if (resObj.status === "error") {
                throw new Error(resObj.msg)
            } else {
                this.setState({
                    checkInstall: response.data.checkInstall,
                    checkClose: response.data.checkClose,
                })
            }
        })
    }

    loadAppMailSettings() {
        axios.get(`${window.SHOPIFY_APP_HOST}/admin/load-config-send-mail`).then((response) => {
            const resObj = response.data
            if (resObj.status === "error") {
                throw new Error(resObj.msg)
            } else {
                let configMail = JSON.parse(resObj.settings[0].value)
                const { actions } = this.props
                actions.changeLayoutMailAction(configMail)
            }
        })
    }

    loadAppReminderMailSettings() {
        axios
            .get(`${window.SHOPIFY_APP_HOST}/admin/load-config-send-reminder-mail`)
            .then((response) => {
                const resObj = response.data
                if (resObj.status === "error") {
                    throw new Error(resObj.msg)
                } else {
                    let configMail = JSON.parse(resObj.settings[0].value)
                    const { actions } = this.props
                    actions.changeLayoutReminderMailAction(configMail)
                }
            })
    }

    loadPlanSettings(props) {
        axios.get(`${window.SHOPIFY_APP_HOST}/admin/load-plan-settings`).then((response) => {
            // let obj = {
            //     plan: response.data.plan,
            // }
            // props.actions.changePlanAction(obj)
            let trial_day = 30
            this.setState({ check: response.data.check })
            if (response.data.buyTheme) {
                this.setState({ trialDay: 90 })
                trial_day = 90
            } else {
                this.setState({ trialDay: 30 })
            }
            let obj = {
                plan: response.data.plan,
                expiration_date: response.data.expiration_date,
                trial_day,
                check: response.data.check,
            }
            if (response.data.plan) {
                props.actions.changePlanAction(obj)
            }
            this.loadTrial(props)
        })
    }

    async test() {
        const { actions } = this.props
        let check = false
        await axios
            .get(`${window.SHOPIFY_APP_HOST}/admin/test-cp`)
            .then((res) => {
                console.log("res", res)
                if (res.data.status) {
                    actions.isInstall(res.data.isInstall)
                    actions.setAttributeCompare(res.data.list)
                    check = true
                    if (!res.data.isInstall) {
                        check = false
                    }
                } else {
                    actions.setAttributeCompare([])
                    check = false
                }
            })
            .catch((err) => {
                console.log("err :>> ", err)
            })
        return check
    }

    async checkInstallAT() {
        const { actions } = this.props
        let check = false
        await axios
            .get(`${window.SHOPIFY_APP_HOST}/admin/check-atranslate`)
            .then((res) => {
                actions.isInstallAT(res.data.status)
            })
            .catch((err) => {
                console.log("err :>> ", err)
            })
        return check
    }

    loadSettings(props, appSettings, checkInstallACF) {
        try {
            let checkTask = this.CheckAppSettings(appSettings)
            if (checkTask === 200) {
                // let settingObj = JSON.parse(appSettings[0].value)
                let settingObj = { ...appSettings }
                // Handle when product amount > 20 for wishlist
                if (window.parentUrl !== clientUrl1 && window.parentUrl !== clientUrl2) {
                    settingObj.wishlist_settings.wishlist_product_number =
                        settingObj.wishlist_settings.wishlist_product_number > 20
                            ? 20
                            : settingObj.wishlist_settings.wishlist_product_number
                } else {
                    settingObj.wishlist_settings.wishlist_product_number =
                        settingObj.wishlist_settings.wishlist_product_number > 100
                            ? 100
                            : settingObj.wishlist_settings.wishlist_product_number
                }

                // Handle when product amount > 4 for compare
                settingObj.compare_settings.compare_product_number =
                    settingObj.compare_settings.compare_product_number > 4
                        ? 4
                        : settingObj.compare_settings.compare_product_number
                // Handle when compare options out list
                settingObj.compare_settings.compare_options =
                    settingObj.compare_settings.compare_options.filter((option) => {
                        return (
                            option === "availability" ||
                            option === "vendor" ||
                            option === "collection" ||
                            option === "options"
                        )
                    })

                //Check if user does not install app ACF
                if (!checkInstallACF) {
                    settingObj.compare_settings.custom_compare = false
                }
                axios
                    .get(`${window.SHOPIFY_APP_HOST}/admin/load-app-text-settings`)
                    .then((response) => {
                        const resObj = response.data
                        if (resObj.status === "error") {
                            throw new Error(resObj.msg)
                        } else {
                            let appSettings = resObj.settings
                            let settingObjText = JSON.parse(appSettings[0].value)
                            settingObj.general_settings.text.wishlist_settings = JSON.parse(
                                JSON.stringify(settingObjText.wishlist_settings),
                            )
                            settingObj.general_settings.text.compare_settings = JSON.parse(
                                JSON.stringify(settingObjText.compare_settings),
                            )
                        }

                        this.setState({
                            app_settings: settingObj,
                        })
                        props.actions.changeAppSettings("wishlist", settingObj.wishlist_settings)
                        props.actions.changeAppSettings("compare", settingObj.compare_settings)
                        props.actions.changeAppSettings("general", settingObj.general_settings)
                        props.actions.changeAppRenderAction("compare", settingObj.compare_settings)
                        props.actions.changeAppRenderAction(
                            "wishlist",
                            settingObj.wishlist_settings,
                        )
                        props.actions.changeAppRenderAction("general", settingObj.general_settings)
                        props.actions.AppNotify({
                            content: "Settings loaded",
                            show: true,
                        })
                    })
                    .catch((err) => {
                        props.actions.AppNotify({
                            content: `${err.message} We will return default settings`,
                            error: true,
                            show: true,
                        })
                    })
                    .finally(() => {
                        this.setState({
                            appWaiting: false,
                            settingLoading: false,
                        })
                    })
            } else {
                let errorMsg = ""
                switch (checkTask) {
                    case 0:
                        errorMsg = "App settings is empty."
                        break
                    case 1:
                        errorMsg = "App settings have malformed syntax."
                        break
                    case 2:
                        errorMsg = "App is missing settings for Wishlist or Compare."
                        break
                    case 21:
                        errorMsg = "Wishlist settings is missing some options."
                        break
                    case 210:
                        errorMsg = "Wishlist settings have incorrect data."
                        break
                    case 22:
                        errorMsg = "Compare settings is missing some options."
                        break
                    case 220:
                        errorMsg = "Compare settings have incorrect data."
                        break
                    default:
                        break
                }
                throw new Error(errorMsg)
            }
        } catch (err) {
            props.actions.AppNotify({
                content: `${err.message} We will return default settings`,
                error: true,
                show: true,
            })
        }
    }

    getMetafieldId() {
        axios
            .get(`${window.SHOPIFY_APP_HOST}/admin/get-metafields-text-settings`)
            .then((response) => {
                const resObj = response.data
                if (resObj.status === "error") {
                    throw new Error(resObj.msg)
                } else {
                    let appSettings = resObj.settings
                    this.setState({ metafieldId: appSettings[0].id })
                }
            })
            .catch((err) => {
                this.props.actions.AppNotify({
                    content: `${err.message} We will return default settings`,
                    error: true,
                    show: true,
                })
            })
    }

    loadAppSettings(props, checkInstallACF) {
        axios
            .get(`${window.SHOPIFY_APP_HOST}/admin/load-app-settings`)
            .then((response) => {
                const resObj = response.data
                if (resObj.status === "error") {
                    throw new Error(resObj.msg)
                } else {
                    let appSettings = resObj.settings
                    // this.setState({ metafieldId: appSettings[0].id })
                    this.loadSettings(props, JSON.parse(appSettings[0].value), checkInstallACF)
                }
            })
            .catch((err) => {
                props.actions.AppNotify({
                    content: `${err.message} We will return default settings`,
                    error: true,
                    show: true,
                })
            })
    }

    /**
     * Close Term and services content
     */
    closePrivacy() {
        this.setState({ showPrivacy: false })
    }

    /**
     * Hide notification func
     */
    hideNotify() {
        const { actions } = this.props
        actions.AppNotify({
            content: "",
            show: false,
            error: false,
        })
    }

    /**
     * FUNCTION TO CHECK APP SETTINGS LOADED FROM STORE
     */
    CheckAppSettings(appSettings: Object): Number {
        // Empty list
        // if (!appSettings.length) {
        //     return 0 // empty list code
        // }

        let settingObj = { ...appSettings }

        // try {
        //     settingObj = JSON.parse(settingObj)
        // } catch (err) {
        //     return 1 // json syntax error code
        // }

        if (!("wishlist_settings" in settingObj) || !("compare_settings" in settingObj)) {
            return 2 // missing wishlist setting or compare setting key
        }

        let wishlistSettings = settingObj.wishlist_settings
        let compareSettings = settingObj.compare_settings

        /**Check wishlist settings */
        if (
            !("wishlist_enable" in wishlistSettings) ||
            !("wishlist_product_number" in wishlistSettings) ||
            !("wishlist_add_class" in wishlistSettings) ||
            !("wishlist_show_class" in wishlistSettings)
        ) {
            return 21 // missing sub setting of wishlist
        } else {
            let _val1 = wishlistSettings["wishlist_enable"]
            let _val2 = wishlistSettings["wishlist_product_number"]
            let _val3 = wishlistSettings["wishlist_add_class"]
            let _val4 = wishlistSettings["wishlist_show_class"]
            if (
                typeof _val1 !== "boolean" ||
                typeof _val2 !== "number" ||
                typeof _val3 !== "string" ||
                typeof _val4 !== "string"
            ) {
                return 210 // data type error of wishlist
            }
        }

        /**Check compare settings */
        if (
            !("compare_enable" in compareSettings) ||
            !("compare_product_number" in compareSettings) ||
            !("compare_add_class" in compareSettings) ||
            !("compare_show_class" in compareSettings) ||
            !("compare_options" in compareSettings)
        ) {
            return 22 // missing sub setting of compare
        } else {
            let _val1 = compareSettings["compare_enable"]
            let _val2 = compareSettings["compare_product_number"]
            let _val3 = compareSettings["compare_add_class"]
            let _val4 = compareSettings["compare_show_class"]
            let _val5 = compareSettings["compare_options"]
            if (
                typeof _val1 !== "boolean" ||
                typeof _val2 !== "number" ||
                typeof _val3 !== "string" ||
                typeof _val4 !== "string" ||
                !Array.isArray(_val5)
            ) {
                return 220 // data type error of compare
            }
        }

        return 200
    }

    /**
     * Save Settings Func
     */
    saveSettings(data, checkImport) {
        const { actions, pages } = this.props
        let checkValidate = this.validateForm()
        let d = new Date()
        if (pages.selected == 0) {
            data.wishlist_settings.updated_at = d.getTime()
        } else data.compare_settings.updated_at = d.getTime()
        if (!checkValidate) return
        // Set loading and disable save button
        this.setState({
            saveState: false,
            appWaiting: true,
        })
        if (checkImport) {
            this.setState({ settingLoading: true })
        }
        this.setState({ app_settings: JSON.parse(JSON.stringify(data)) })
        setTimeout(() => {
            axios
                .post(`${window.SHOPIFY_APP_HOST}/admin/save-app-settings`, this.state.app_settings)
                .then((response) => {
                    const resObj = response.data
                    if (resObj.status === "success") {
                        // Update root state
                        actions.changeAppSettings(
                            "wishlist",
                            this.state.app_settings.wishlist_settings,
                        )
                        actions.changeAppSettings(
                            "compare",
                            this.state.app_settings.compare_settings,
                        )
                        actions.changeAppSettings(
                            "general",
                            this.state.app_settings.general_settings,
                        )

                        actions.changeAppRenderAction(
                            "compare",
                            this.state.app_settings.compare_settings,
                        )
                        actions.changeAppRenderAction(
                            "wishlist",
                            this.state.app_settings.wishlist_settings,
                        )
                        actions.changeAppRenderAction(
                            "general",
                            this.state.app_settings.general_settings,
                        )

                        actions.changeAppEditedAction("wishlist_settings_edited", [])
                        actions.changeAppEditedAction("compare_settings_edited", [])
                        actions.changeAppEditedAction("general_settings_edited", [])
                    } else {
                        throw new Error(resObj.msg)
                    }

                    axios
                        .post(
                            `${window.SHOPIFY_APP_HOST}/admin/save-app-text-settings`,
                            this.state.app_settings.general_settings,
                        )
                        .then((response) => {
                            const resObj = response.data
                            if (resObj.status === "success") {
                                actions.AppNotify({
                                    content: resObj.msg,
                                    show: true,
                                    error: false,
                                })
                            } else {
                                throw new Error(resObj.msg)
                            }
                        })
                        .catch((err) => {
                            actions.AppNotify({
                                content: `${err.message}. Please try again.`,
                                show: true,
                                error: true,
                            })
                        })
                        .finally(() => {
                            this.setState({
                                appWaiting: false,
                                checkProcess: true,
                            })
                            window.scrollTo({ top: 0, behavior: "smooth" })
                            if (checkImport) {
                                this.setState({ settingLoading: false })
                            }
                            let width = 1
                            let time = setInterval(() => {
                                if (width >= 100) {
                                    width = 0
                                    this.setState({ checkProcess: false })
                                    this.setState({ process: width })
                                    clearInterval(time)
                                } else {
                                    width += 10
                                    this.setState({ process: width })
                                }
                            }, 2000)
                        })
                })
                .catch((err) => {
                    actions.AppNotify({
                        content: `${err.message}. Please try again.`,
                        show: true,
                        error: true,
                    })
                })
        }, 0)
    }

    /**
     * Discard Settings Func
     */
    clearSettings() {
        this.setState({
            app_settings: this.props.app_settings,
            wishlist_settings_edited: [],
            compare_settings_edited: [],
            general_settings_edited: [],
        })
    }

    /**
     * Validate form before submit
     */
    validateForm() {
        const { wishlist_settings_edited, compare_settings_edited, general_settings_edited } =
            this.props.app_edited
        const pattern = /^[0-9a-zA-Z]+[-_]*[0-9a-zA-Z]+$/gm
        const wishlist_add_class = wishlist_settings_edited.find(
            (item) => Object.keys(item)[0] === "wishlist_add_class",
        )
        const wishlist_show_class = wishlist_settings_edited.find(
            (item) => Object.keys(item)[0] === "wishlist_show_class",
        )
        const wishlist_remove_class = wishlist_settings_edited.find(
            (item) => Object.keys(item)[0] === "wishlist_remove_class",
        )
        const compare_add_class = compare_settings_edited.find(
            (item) => Object.keys(item)[0] === "compare_add_class",
        )
        const compare_show_class = compare_settings_edited.find(
            (item) => Object.keys(item)[0] === "compare_show_class",
        )
        const compare_remove_class = compare_settings_edited.find(
            (item) => Object.keys(item)[0] === "compare_remove_class",
        )

        // validate wishlist add class
        let validatePass1 = this.validateEmptyAndSyntax(wishlist_add_class, "error_1", pattern)
        // validate wishlist show class
        let validatePass2 = this.validateEmptyAndSyntax(wishlist_show_class, "error_2", pattern)
        // validate wishlist remove class
        let validatePass2a = this.validateEmptyAndSyntax(wishlist_remove_class, "error_2a", pattern)
        // validate compare add class
        let validatePass3 = this.validateEmptyAndSyntax(compare_add_class, "error_3", pattern)
        // validate compare show class
        let validatePass4 = this.validateEmptyAndSyntax(compare_show_class, "error_4", pattern)
        // validate compare remove class
        let validatePass4a = this.validateEmptyAndSyntax(compare_remove_class, "error_4a", pattern)

        let validateAll =
            validatePass1 &
            validatePass2 &
            validatePass2a &
            validatePass3 &
            validatePass4 &
            validatePass4a

        return validateAll
    }

    validateEmptyAndSyntax(validateObj, errorKey, syntax) {
        let validatePass = true
        if (validateObj) {
            var val = Object.values(validateObj)[0]
            if (!val) {
                this.setState({
                    errorValidate: {
                        ...this.state.errorValidate,
                        [errorKey]: "This field cannot empty",
                    },
                })
                validatePass = false
            } else {
                var match = val.match(syntax)
                if (!match) {
                    this.setState({
                        errorValidate: {
                            ...this.state.errorValidate,
                            [errorKey]: "Please enter correctly format for class name",
                        },
                    })
                    validatePass = false
                }
            }
        }

        return validatePass
    }

    handleClose() {
        this.setState({ show: false })
    }

    handleShow = () => {
        this.setState({ show: true })
    }

    handleReInstall() {
        const { selectReinstall, selected } = this.state
        const { actions } = this.props
        let data = {
            id: selected,
            option: selectReinstall[0],
        }
        this.setState({
            appWaiting: true,
            show: false,
        })
        axios
            .post(`${window.SHOPIFY_APP_HOST}/admin/install-wishlist-assets`, data)
            .then((response) => {
                const resObj = response.data
                if (resObj.status === "success") {
                    this.props.actions.AppNotify({
                        content: "Re-install successfully",
                        show: true,
                        error: false,
                    })
                    setTimeout(() => {
                        window.location.reload()
                    }, 0)
                } else {
                    throw new Error(resObj.msg)
                }
            })
            .catch((err) => {
                actions.AppNotify({
                    content: `Re-install fail. Please try again.`,
                    show: true,
                    error: true,
                })
            })
            .finally(() => {
                this.setState({
                    appWaiting: false,
                })
            })
    }

    loadTrial(props) {
        axios.get(`${window.SHOPIFY_APP_HOST}/admin/get-trial`).then((res) => {
            let trial_day = 30
            this.setState({ check: res.data.check })
            if (res.data.buyTheme) {
                this.setState({ trialDay: 90 })
                trial_day = 90
            } else {
                this.setState({ trialDay: 30 })
            }
            let obj = {
                check: res.data.check,
                plan: res.data.plan,
                expiration_date: res.data.expiration_date,
                trial_day,
            }
            if (res.data.plan) {
                props.actions.changePlanAction(obj)
            }
        })
    }

    handleTrial() {
        axios.get(`${window.SHOPIFY_APP_HOST}/admin/trial`).then((res) => {
            this.setState({ check: res.data.check })
            window.location.reload()
        })
    }

    handleChangeTabs = async (item, index) => {
        this.setState({
            tabSelected: index,
        })
    }

    handleClickTabs = async (pages, index) => {
        const { actions } = this.props
        actions.switchPagesAction(pages)
        if (index != null) {
            let item = {
                id: index,
            }
            await actions.changeWidgetSelectedAction(item)
            actions.switchPagesConfigAction("WidgetsSetting")
            let content = document.querySelector(".widget-create")
            content.scrollIntoView()
        } else {
            await actions.switchPagesConfigAction("WidgetsManagement")
            let content = document.querySelector(".widgets-management-body")
            content.scrollIntoView()
        }
    }

    toggleActive = () => {
        this.setState({ active: !this.state.active })
    }

    handleChangeParentTabs = (index) => {
        this.setState({ parentTabs: index })
    }

    handleCloseTabs = () => {
        axios.get(`${window.SHOPIFY_APP_HOST}/admin/close-tabs`).then((response) => {
            const resObj = response.data
            if (resObj.status === "error") {
                throw new Error(resObj.msg)
            } else {
                this.setState({
                    checkClose: response.data.checkClose,
                })
            }
        })
    }

    handleUpdateVersion = () => {
        this.setState({
            appWaiting: true,
            show: false,
        })
        axios
            .get(`${window.SHOPIFY_APP_HOST}/admin/update-version`)
            .then((response) => {
                const resObj = response.data
                if (resObj.status === "success") {
                    this.props.actions.AppNotify({
                        content: "Update successfully",
                        show: true,
                        error: false,
                    })
                    setTimeout(() => {
                        window.location.reload()
                    }, 0)
                } else {
                    throw new Error(resObj.msg)
                }
            })
            .catch((err) => {
                actions.AppNotify({
                    content: `Re-install fail. Please try again.`,
                    show: true,
                    error: true,
                })
            })
            .finally(() => {
                this.setState({
                    appWaiting: false,
                })
            })
    }

    render() {
        try {
            const { acceptedDate, notification } = this.props
            const {
                app_settings,
                saveState,
                showPrivacy,
                appWaiting,
                errorValidate,
                settingLoading,
                iconsSet,
                show,
                hasError,
                check,
                selected,
                optionThemes,
                selectReinstall,
                checkInstall,
                trialDay,
                checkClose,
                tabSelected,
                active,
                checkProcess,
                process,
                released_update,
                parentTabs,
                showUpdate,
                themesInstall,
                metafieldId,
            } = this.state
            const { wishlist_settings, compare_settings, general_settings } = app_settings
            // App Toast
            const notifyToast = notification.show ? (
                <Toast
                    error={notification.error}
                    content={notification.content}
                    onDismiss={this.hideNotify.bind(this)}
                />
            ) : null

            let activeText = checkInstall ? "Reactive" : "Active"
            let themeName = ""
            let themeSelected = optionThemes.find((item) => item.value == selected)
            if (themeSelected) {
                themeName = themeSelected.label
            }

            let wishlistTabs = {
                content: "Wishlist",
                onAction: () => this.handleChangeParentTabs(0),
            }

            let compareTabs = {
                content: "Compare",
                onAction: () => this.handleChangeParentTabs(1),
            }

            let closeTabs = {
                content: "Close",
                onAction: () => this.handleCloseTabs(),
            }

            const moreTabs = []

            parentTabs == 0 ? moreTabs.push(compareTabs) : moreTabs.push(wishlistTabs)
            moreTabs.push(closeTabs)
            return !showPrivacy ? (
                !hasError ? (
                    <div>
                        <div className="App-Main-Content">
                            <svg
                                xmlnsXlink="http://www.w3.org/2000/svg"
                                style={{ display: "none" }}
                            >
                                {/** Wishlist icon symbols */}
                                <symbol id="arn_icon-add-wishlist" viewBox="0 0 32 32">
                                    <g
                                        style={{
                                            fill: wishlist_settings.add_class_icon.icon_color,
                                        }}
                                        dangerouslySetInnerHTML={{
                                            __html: wishlist_settings.add_class_icon.svg,
                                        }}
                                    ></g>
                                </symbol>

                                <symbol id="arn_icon-add-wishlist__active" viewBox="0 0 32 32">
                                    <g
                                        style={{
                                            fill: wishlist_settings.add_class_icon
                                                .icon_active_color,
                                        }}
                                        dangerouslySetInnerHTML={{
                                            __html: wishlist_settings.add_class_icon.svg,
                                        }}
                                    ></g>
                                </symbol>

                                <symbol id="arn_icon-show-wishlist" viewBox="0 0 32 32">
                                    <g
                                        style={{
                                            fill: wishlist_settings.show_class_icon.icon_color,
                                        }}
                                        dangerouslySetInnerHTML={{
                                            __html: wishlist_settings.show_class_icon.svg,
                                        }}
                                    ></g>
                                </symbol>

                                <symbol id="arn_icon-remove-wishlist" viewBox="0 0 32 32">
                                    <g
                                        style={{
                                            fill: wishlist_settings.remove_class_icon.icon_color,
                                        }}
                                        dangerouslySetInnerHTML={{
                                            __html: wishlist_settings.remove_class_icon.svg,
                                        }}
                                    ></g>
                                </symbol>

                                {/** Compare icon symbols */}
                                <symbol id="arn_icon-add-compare" viewBox="0 0 32 32">
                                    <g
                                        style={{ fill: compare_settings.add_class_icon.icon_color }}
                                        dangerouslySetInnerHTML={{
                                            __html: compare_settings.add_class_icon.svg,
                                        }}
                                    ></g>
                                </symbol>

                                <symbol id="arn_icon-add-compare__active" viewBox="0 0 32 32">
                                    <g
                                        style={{
                                            fill: compare_settings.add_class_icon.icon_active_color,
                                        }}
                                        dangerouslySetInnerHTML={{
                                            __html: compare_settings.add_class_icon.svg,
                                        }}
                                    ></g>
                                </symbol>

                                <symbol id="arn_icon-show-compare" viewBox="0 0 32 32">
                                    <g
                                        style={{
                                            fill: compare_settings.show_class_icon.icon_color,
                                        }}
                                        dangerouslySetInnerHTML={{
                                            __html: compare_settings.show_class_icon.svg,
                                        }}
                                    ></g>
                                </symbol>

                                <symbol id="arn_icon-remove-compare" viewBox="0 0 32 32">
                                    <g
                                        style={{
                                            fill: compare_settings.remove_class_icon.icon_color,
                                        }}
                                        dangerouslySetInnerHTML={{
                                            __html: compare_settings.remove_class_icon.svg,
                                        }}
                                    ></g>
                                </symbol>

                                {/** Preloader icon symbol */}
                                <symbol id="arn_icon-preloader" viewBox="0 0 32 32">
                                    <g
                                        style={{ fill: general_settings.preloader_color }}
                                        dangerouslySetInnerHTML={{
                                            __html: general_settings.preloader_svg,
                                        }}
                                    ></g>
                                </symbol>
                            </svg>
                            <div className="app-header-bar">
                                <Page className="app-header-bar">
                                    <TitleBar
                                        className="app-header-bar"
                                        title="Wishslist - Compare"
                                        secondaryActions={[
                                            {
                                                content: "Terms Of Service",
                                                onAction: () => {
                                                    this.setState({
                                                        showPrivacy: true,
                                                    })
                                                },
                                            },
                                            // {
                                            //     content: activeText,
                                            //     onAction: () => {
                                            //         this.handleShow()
                                            //     },
                                            // },
                                        ]}
                                        primaryAction={{
                                            content: "Save",
                                            disabled: !saveState,
                                            onAction: () => {
                                                this.saveSettings(this.props.app_render, false)
                                            },
                                        }}
                                    />

                                    <div className="App-Body">
                                        <Modal
                                            open={show}
                                            onClose={() => this.handleClose()}
                                            title="Install Theme"
                                            primaryAction={{
                                                content: "Save Changes",
                                                onAction: () => this.handleReInstall(),
                                            }}
                                            secondaryActions={[
                                                {
                                                    content: "Close",
                                                    onAction: () => this.handleClose(),
                                                },
                                            ]}
                                        >
                                            <Modal.Section>
                                                <TextContainer>
                                                    <div>
                                                        <ChoiceList
                                                            choices={[
                                                                {
                                                                    label: "Return default settings",
                                                                    value: "0",
                                                                },
                                                                {
                                                                    label: "Keep old settings adding new options only",
                                                                    value: "1",
                                                                },
                                                            ]}
                                                            selected={selectReinstall}
                                                            onChange={(val) => {
                                                                this.setState({
                                                                    selectReinstall: val,
                                                                })
                                                            }}
                                                        />

                                                        <Select
                                                            label="Active Theme"
                                                            options={optionThemes}
                                                            onChange={(value) => {
                                                                this.setState({
                                                                    selected: +value,
                                                                })
                                                            }}
                                                            value={selected}
                                                        />
                                                    </div>
                                                </TextContainer>
                                            </Modal.Section>
                                        </Modal>
                                    </div>
                                    {appWaiting ? <Preloader /> : null}
                                    {notifyToast}
                                </Page>
                            </div>

                            <Stack vertical>
                                {check && (
                                    <div className="noti-trial" style={{ marginBottom: "20px" }}>
                                        <Card sectioned>
                                            <Stack alignment="center">
                                                <Heading>FREE TRIAL {trialDay} days</Heading>
                                                <p>
                                                    Try all of our features absolutely for free for{" "}
                                                    {trialDay} days! We want you to have a better
                                                    idea of how the app works and see how it can
                                                    bring you a value. After, you will be
                                                    automatically reverted back to the “Free” plan,
                                                    so you will NOT be charged.
                                                </p>
                                                <Button onClick={() => this.handleTrial()}>
                                                    Try all Wishlist - Compare Features for free
                                                </Button>
                                            </Stack>
                                        </Card>
                                    </div>
                                )}
                                {showUpdate ? (
                                    <div className="noti-update" style={{ marginBottom: "20px" }}>
                                        <Card sectioned>
                                            <Stack vertical>
                                                <Heading>App has new update for storefront</Heading>
                                                <p>
                                                    <b>Release date:</b>{" "}
                                                    <span style={{ color: "#FFFF00" }}>
                                                        {formatDateTime(
                                                            released_update,
                                                            "Month DD, YYYY",
                                                        )}
                                                    </span>
                                                </p>
                                                <p>
                                                    <b>Note:</b> For user who installed after{" "}
                                                    <span style={{ color: "#FFFF00" }}>
                                                        {formatDateTime(
                                                            released_update,
                                                            "Month DD, YYYY",
                                                        )}
                                                    </span>
                                                    . Please ignore this.
                                                </p>
                                                <Button onClick={() => this.handleUpdateVersion()}>
                                                    Update now
                                                </Button>
                                            </Stack>
                                        </Card>
                                    </div>
                                ) : (
                                    ""
                                )}

                                {checkProcess && (
                                    <div style={{ marginBottom: "20px" }}>
                                        <Card sectioned>
                                            <Heading>Updating settings</Heading>
                                            <ProgressBar progress={process} size="small" />
                                        </Card>
                                    </div>
                                )}
                            </Stack>
                            {appWaiting ? null : (
                                <AppMain
                                    checkClose={checkClose}
                                    checkInstall={checkInstall}
                                    optionThemes={optionThemes}
                                    themesInstall={themesInstall}
                                    selected={selected}
                                    metafieldId={metafieldId}
                                    handleShow={this.handleShow}
                                />
                            )}
                        </div>
                    </div>
                ) : (
                    <h1>Something went wrong.</h1>
                )
            ) : (
                <PrivacyContent
                    acceptedDate={acceptedDate}
                    closePrivacy={this.closePrivacy.bind(this)}
                />
            )
        } catch (error) {
            console.log(error)
        }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(AppCont)
